/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { SpinnerIcon } from "src/assets/icons/loading-spinner";

const StyledSpinner = styled(SpinnerIcon)`
  width: 20px;
  height: 20px;
  animation: spin 0.6s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default () => <StyledSpinner />;
